import "./Skeleton.css";

export const Skeleton = ({ sx, className, height, width, children }) => {
  return (
    <div className={`skeleton ${className}`} style={{ ...sx, height, width }}>
      {children}
    </div>
  );
};
